import { removeClass, addClass, gebc, qsa } from "@qneyraud/q-utils/umd/q-utils.js";
import { observeChildren } from "@lib/helpers/observer";
import Highway from "@dogstudio/highway";
import Factory from "@lib/Factory";
import EventBus from "@lib/helpers/event-bus";

export default class Page extends Highway.Renderer {
  constructor(datas) {
    super(datas);

    this.uid =
      "_" +
      Math.random()
        .toString(36)
        .substr(2, 9);
    this.$bus = EventBus;
  }

  onLeave() {
    this.traverse("onLeave");
    addClass(document.body, "loading");
  }

  onLeaveCompleted() {
    this.traverse("onLeaveCompleted");
  }

  onEnter() {
    window.scrollTo(0, 0);

    this.el = this.wrap.lastElementChild;

    this.setChildren();
    this.traverse("onEnter");

    this.setRefs();
    this.datas = this.el.dataset;
    this.setElementUid();
  }

  onEnterCompleted() {
    this.traverse("onEnterCompleted");
    removeClass(document.body, "loading");
    observeChildren(this.el);
  }

  setElementUid() {
    this.el.dataset.uid = this.uid;
  }

  setRefs() {
    this.refs = {};
    this.refs = qsa(this.el, "[ref]")
      .filter(this.isInElementScope.bind(this))
      .reduce((acc, el) => {
        const refValue = el.getAttribute("ref");

        if (Array.isArray(acc[refValue])) {
          acc[refValue].push(el);
        } else if (acc[refValue]) {
          acc[refValue] = [acc[refValue], el];
        } else {
          acc[refValue] = el;
        }

        return acc;
      }, {});
  }

  setChildren() {
    this.children = [];

    this.children = gebc(this.el, "component", true)
      .filter(this.isInElementScope.bind(this))
      .map((componentEl) => {
        const component = Factory.createComponent(componentEl, {
          parent: this,
          renderer: this,
          wrap: this.wrap
        });
        component.createElement();
        component.init();
        return component;
      });
  }

  getChildren() {
    return this.children;
  }

  getChildrenById(id) {
    return this.children.filter((child) => child.id === id);
  }

  getChildByUid(uid) {
    return this.children.find((child) => child.uid === uid);
  }

  traverse(methodName, datas = null) {
    this.children.forEach((child) => {
      child.traverse(methodName, datas);
    });
  }

  isInElementScope(el) {
    return el.parentNode.closest(".component") === null;
  }
}



// WEBPACK FOOTER //
// ./scripts/lib/Page.js